export default __webpack_public_path__ + "static/media/inner-zero-touches-production.c3493356.svg";